import globalRolesMixin from './globalRoles';
import companyRolesMixin from './companyRoles';

export default {
  mixins: [globalRolesMixin, companyRolesMixin],
  computed: {
    contextCompanyId () {
      return this.company?.id || null;
    },
    contextCompanyRole () {
      return this.userCompanyRole(this.contextCompanyId);
    },
    userHasContextCompanyRole () {
      return this.contextCompanyRole !== null;
    },
    userIsContextCompanyConsultant () {
      return this.contextCompanyRole === 'consultant' || this.contextCompanyRole === 'supervisor';
    },
    userIsContextCompanyOwner () {
      return this.contextCompanyRole === 'owner';
    },
    userIsContextCompanyManager () {
      return this.contextCompanyRole === 'manager';
    },
    userIsContextCompanyVisitor () {
      return this.contextCompanyRole === 'visitor';
    },
  },
};
